namespace distill.datasets.views.createWizard2_fields {
    enum DatasetCreationMethod {
        None = "None",
        Manual = "Manual",
        FormScreen = "FormScreen",
        DataSource = "DataSource",
        FileUpload = "FileUpload"
    }

    class InitArgs {
        wizardToken: string = '';
        creationMethod: DatasetCreationMethod = DatasetCreationMethod.None;
        selectedAutoFields: string[] = [];
        selectedSingularFields: string[] = [];
        selectedRepeatFields: string[] = [];
        generateRepeatRows: boolean = false;
        hasSingleRepeat: boolean = false;
        repeatGroups: IRepeatGroup[] = [];
        repeatFieldsByAnchor: { [key: string]: any[] } = {};
        urls!: {
            navigateToStep: string;
        };
    }

    interface IRepeatGroup {
        name: string;
        breadcrumb: string;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        $(function () {
            bindEvents();
            
            if (_initArgs.generateRepeatRows) {
                const anchor = $('#repeatAnchorPicker').val()?.toString();
                if (anchor)
                    handleRepeatAnchorChange(anchor);
            }
        });
    }

    function getParentButton(selector: string): JQuery<HTMLElement> {
        return $(parent.document).find(selector) as unknown as JQuery<HTMLElement>;
    }

    function bindEvents(): void {
        getParentButton('#wizardBackBtn').on('click', function (e) {
            e.preventDefault();
            window.location.href = _initArgs.urls.navigateToStep + '?step=2&token=' + _initArgs.wizardToken;
        });

        getParentButton('#wizardNextBtn').on('click', function () {
            if (validateStep())
                submitForm();
        });

        $(document).on('change', '#GenerateRepeatRows', function () {
            const checked = $(this).is(':checked');
            if (checked) {
                $('#repeatAnchorWrapper').removeClass('d-none');
                const anchorName = $('#repeatAnchorPicker').val()?.toString() || '';
                if (anchorName)
                    handleRepeatAnchorChange(anchorName);
            } else
                $('#repeatAnchorWrapper, #repeatFieldsSection').addClass('d-none');
            
            appn.iframe.setModalIframeHeight(true);
        });

        $(document).on('change', '#repeatAnchorPicker', function () {
            const anchorName = $(this).val()?.toString() || '';
            handleRepeatAnchorChange(anchorName);
        });
    }

    function handleRepeatAnchorChange(anchorName: string): void {
        const $select = $('#repeatFieldsSelect');
        $select.empty();

        const isGenerating = $('#GenerateRepeatRows').is(':checked');
        if (anchorName && isGenerating) {
            const columns = _initArgs.repeatFieldsByAnchor[anchorName] || [];
            columns.forEach(col => {
                if (col.alwaysIncluded) return;
                
                const isSelected = _initArgs.selectedRepeatFields.includes(col.id);
                $select.append(`<option value="${col.id}" ${isSelected ? 'selected' : ''}>${col.displayName}</option>`);
            });
            $('#repeatFieldsSection').removeClass('d-none');
            ($select as any).bootstrapDualListbox('refresh');
        } else {
            $('#repeatFieldsSection').addClass('d-none');
        }
    }

    function validateStep(): boolean {
        if ($('#GenerateRepeatRows').is(':checked')) {
            const anchor = $('#repeatAnchorPicker').val()?.toString() || '';
            if (!anchor) {
                appn.toast.notify(appn.toast.Type.error, T('Please choose a repeat group from which to generate rows.'));
                return false;
            }
            const repeatCount = ($('#repeatFieldsSelect').val() as string[])?.length || 0;
            if (repeatCount === 0) {
                appn.toast.notify(appn.toast.Type.error, T('At least one repeat field must be selected when generating rows.'));
                return false;
            }
        }
        return true;
    }

    function submitForm(): void {
        ($('form')[0] as HTMLFormElement).submit();
    }
}
